<div class="mega_body-content">
  <ng-container *ngIf="warningMessage.show">
    <div class="row error-banner-container">
      <div class="col-1 col-sm-1 col-md-1 col-lg-1">
        <div class="status-icon float-end">
          <img alt="" src="assets/images/icon_error_white.svg" />
        </div>
      </div>
      <div class="col-12 col-sm-12 col-md-9 col-lg-9">
        <p class="file-format-text">{{ warningMessage.message }}</p>
      </div>
      <div class="col-1 col-sm-1 col-md-2 col-lg-2">
        <div class="exit-button float-end" (click)="closeCommitErrorBanner()">
          <img src="assets/images/x_white.svg" />
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showBanner">
    <div class="col-12 col-sm-12 col-md-12 col-lg-12">
      <div class="message-container message-container--info">
        <div class="row">
          <span class="col-1 col-sm-1 col-md-1 col-lg-1 status-icon fa-stack fa-lg">
            <i class="fa fa-info fa-stack-1x"></i>
            <i class="fa fa-circle-thin fa-stack-2x"></i>
          </span>
          <div class="col-11 col-sm-11 col-md-11 col-lg-11 status-message early-close-banner">
            {{ messageBody }}
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 mega_header-information">
    <ng-container *ngIf="!isEditMegaFlow">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">Review Pool Details</div>
        </div>
        <div
          class="col-12 col-sm-12 col-md-4 col-lg-4 back-and-edit visible-md-4 visible-lg-4 float-end"
          (click)="goBack()"
        >
          <i class="fa fa-arrow-circle-o-left go-back-icon"></i>Go back and edit
        </div>
        <p class="col-12 col-sm-12 col-md-8 col-lg-8">
          Below are the details of your pool. You may go back to make changes or click the Commit
          button to finalize this transaction. At this time you will receive your Pool Number and
          CUSIP.
        </p>
        <div
          class="col-12 col-sm-12 col-md-4 col-lg-4 back-and-edit-screen hidden-md hidden-lg float-end"
          (click)="goBack()"
        >
          <i class="fa fa-arrow-circle-o-left go-back-icon"></i>Go back and edit
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isEditMegaFlow">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
          <div class="mega_header-information__sub-header">
            Review Pool Changes ({{ poolNumber }})
          </div>
        </div>
        <div
          class="col-12 col-sm-12 col-md-4 col-lg-3 back-and-edit visible-md-4 visible-lg-3 float-end"
          (click)="goBack()"
        >
          <i class="fa fa-arrow-circle-o-left go-back-icon"></i>Go back and edit
        </div>
        <p class="col-12 col-sm-12 col-md-6 col-lg-6">
          Below is an overview of the changes you made to your pool. The Pool Number and CUSIP from
          your original commitment have not changed.
        </p>
        <div
          class="col-12 col-sm-12 col-md-4 col-lg-2 back-and-edit-screen hidden-md hidden-lg float-end"
          (click)="goBack()"
        >
          <i class="fa fa-arrow-circle-o-left go-back-icon"></i>Go back and edit
        </div>
      </div>
    </ng-container>
  </div>

  <div class="col-12 col-sm-12 col-md-12 col-lg-12 line-break-container">
    <div class="line-break"></div>
  </div>
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
      <div>Pool Type</div>
    </div>
  </div>
  <div class="row col-12 col-sm-12 col-md-12 col-lg-12 pl-0">
    <div class="col-12 col-sm-12 col-md-3 col-lg-3">
      <div class="fw-bold-and-size">
        <ng-container *ngIf="calcFeeRes.megaType === 'SFFIXMEGA'">
          Single Family Fixed Rate
        </ng-container>
        <ng-container *ngIf="calcFeeRes.megaType === 'SFARMMEGA'"> Single Family ARM </ng-container>
        <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
          Multi Family Fixed Rate
        </ng-container>
        <ng-container *ngIf="calcFeeRes.megaType === 'MFARMMEGA'"> Multi Family ARM </ng-container>
      </div>
    </div>
    <div class="col-12 col-sm-12 col-md-9 col-lg-9 visible-md-9 pr-0 d-flex justify-content-end">
      <span class="fw-bold-and-size">Total Pools: 1</span>
    </div>
    <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12">
      <span class="fw-bold-and-size col-12 pl-0">Total Pools: 1</span>
    </div> -->
  </div>
  <div class="row">
    <div class="col-12 mt-10">
      <div class="fm-cdx-table">
        <table class="fm-cdx-table__static">
          <thead>
            <tr class="th_row">
              <th class="th_column">POOL #</th>
              <th class="th_column width-25">CUSIP</th>
              <th class="th_column width-25">PREFIX</th>
              <ng-container *ngIf="calcFeeRes.megaType === 'SFFIXMEGA'">
                <th class="th_column th_column--is-numeric">COUPON</th>
              </ng-container>
              <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                <th class="th_column th_column--is-numeric">HIGH COUPON</th>
              </ng-container>
              <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                <th class="th_column th_column--is-numeric">LOW COUPON</th>
              </ng-container>
              <ng-container
                *ngIf="calcFeeRes.megaType === 'SFARMMEGA' || calcFeeRes.megaType === 'MFARMMEGA'"
              >
                <th class="th_column">SUBTYPE</th>
              </ng-container>
              <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
              <th class="th_column pl-85">SETTLEMENT</th>
              <th class="th_column th_column--is-numeric">FEE</th>
            </tr>
          </thead>
          <tbody>
            <tr class="td_row commit-mega-table-header">
              <ng-container *ngIf="isEditMegaFlow">
                <td class="td_cell">
                  <span id="megaNumberEdit"> {{ poolNumber }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="!isEditMegaFlow">
                <td class="td_cell">
                  <span id="megaNumber" class="commit-to-recive-color">Commit to Receive</span>
                </td>
              </ng-container>
              <ng-container *ngIf="isEditMegaFlow">
                <td class="td_cell">
                  <span id="cusipEdit"> {{ cusip }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="!isEditMegaFlow">
                <td class="td_cell">
                  <span id="cusip" class="commit-to-recive-color">Commit to Receive</span>
                </td>
              </ng-container>
              <td class="td_cell">
                <span id="prefix">{{ calcFeeRes?.prefixCode ? calcFeeRes?.prefixCode : '' }}</span>
              </td>
              <ng-container *ngIf="calcFeeRes.megaType === 'SFFIXMEGA'">
                <td class="td_cell td_cell--is-numeric">
                  <span id="sfFixedCoupon">{{ calcFeeRes?.sfFixedCoupon | number: '1.3-3' }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                <td class="td_cell td_cell--is-numeric">
                  <span id="mfHighCoupon">{{ calcFeeRes?.mfHighCoupon | number: '1.3-3' }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="calcFeeRes.megaType === 'MFFIXMEGA'">
                <td class="td_cell td_cell--is-numeric">
                  <span id="mfLowCoupon">{{ calcFeeRes?.mfLowCoupon | number: '1.3-3' }}</span>
                </td>
              </ng-container>
              <ng-container
                *ngIf="calcFeeRes.megaType === 'SFARMMEGA' || calcFeeRes.megaType === 'MFARMMEGA'"
              >
                <td class="td_cell">
                  <span id="sfARMSubType">{{ calcFeeRes?.sfARMSubType }}</span>
                </td>
              </ng-container>
              <td class="td_cell td_cell--is-numeric">
                <span id="tradeAmount">{{
                  calcFeeRes?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                }}</span>
              </td>
              <ng-container *ngIf="!showEarlyCloseLegend">
                <td class="td_cell">
                  <span id="tradeSettlementDate">{{
                    calcFeeRes?.tradeSettlementDate | date: 'MM/dd/yyyy'
                  }}</span>
                </td>
              </ng-container>
              <ng-container *ngIf="showEarlyCloseLegend">
                <td class="td_cell">
                  <span id="tradeSettlementDate-earlyClose"
                    >{{ calcFeeRes?.tradeSettlementDate | date: 'MM/dd/yyyy'
                    }}<i class="fa fa-asterisk legend-icon pl-3"></i
                  ></span>
                </td>
              </ng-container>
              <ng-container *ngIf="calcFeeRes?.feeDollars !== null">
                <td class="td_cell td_cell--is-numeric">
                  <ng-container *ngIf="showDisclaimer">
                    <span id="newFeeDollars" class="fw-bold fee-warning-red"
                      >{{ calcFeeRes?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}*</span
                    >
                  </ng-container>
                  <ng-container *ngIf="!showDisclaimer">
                    <span id="newFeeDollars" class="fw-bold"
                      >{{ calcFeeRes?.feeDollars | currency: 'USD' : 'symbol' : '1.2-2' }}
                    </span>
                  </ng-container>
                </td>
              </ng-container>
              <ng-container *ngIf="calcFeeRes?.feeTicks !== null">
                <td class="td_cell td_cell--is-numeric">
                  <ng-container *ngIf="showDisclaimer">
                    <span id="newFeeTicks" class="fw-bold fee-warning-red"
                      >{{ calcFeeRes?.feeTicks | number: '1.3-3' }}/32*
                    </span>
                  </ng-container>
                  <ng-container *ngIf="!showDisclaimer">
                    <span id="newFeeTicks" class="fw-bold"
                      >{{ calcFeeRes?.feeTicks | number: '1.3-3' }}/32
                    </span>
                  </ng-container>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="fee-warning-red">{{ disclaimerMessage }}</p>
    </div>
  </div>
  <div class="row" *ngIf="showEarlyCloseLegend">
    <div class="col-12 mt-25">
      <p>
        <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be sure
        someone from the Structured Transactions team is available to complete this transaction.
      </p>
    </div>
  </div>
  <!--Mega pricing updates section-->
  <section class="mega-pricing-updates-section mt-25" *ngIf="megaPricingUpdateList.length > 0">
    <div class="row">
      <div class="col-12 col-md-9">
        <span>
          <i class="fa fa-exclamation-triangle warning-exclamation-icon"></i>
          <span
            >Upon commiting the above, pricing for the following committed pools will be
            affected</span
          >
        </span>
      </div>
      <div class="col-12 col-md-3 visible-md-3 pr-0 d-flex justify-content-end">
        <span>Total Pools: {{ megaPricingUpdateList.length }}</span>
      </div>
      <!-- <div class="visible-xs-12 hidden-md hidden-lg col-12">
        <span class="col-12 pl-0">Total Pools: {{ megaPricingUpdateList.length }}</span>
      </div> -->
    </div>
    <div class="row" *ngIf="megaPricingUpdateList !== null">
      <div class="col-12 mega-pricing-update-table px-0">
        <div class="fm-cdx-table">
          <table class="fm-cdx-table__static">
            <thead>
              <tr class="th_row">
                <th class="th_column">POOL #</th>
                <th class="th_column width-25">CUSIP</th>
                <th class="th_column th_column--is-numeric">DEAL AMOUNT</th>
                <th class="th_column pl-85">SETTLEMENT</th>
                <th class="th_column th_column--is-numeric">PREVIOUS FEE</th>
                <th class="th_column th_column--is-numeric">NEW FEE</th>
              </tr>
            </thead>
            <tbody>
              <tr
                class="td_row commit-mega-pricing-update-table-header"
                *ngFor="let megaPricing of megaPricingUpdateList; trackBy: trackByIdentity"
              >
                <td class="td_cell">
                  <span class="pool-item-mega-number">{{ megaPricing?.poolNumber }}</span>
                </td>
                <td class="td_cell">
                  <span class="pool-item-cusip">{{ megaPricing?.cusip }}</span>
                </td>
                <td class="td_cell td_cell--is-numeric">
                  <span class="pool-item-trade-amount">{{
                    megaPricing?.tradeAmount | currency: 'USD' : 'symbol' : '1.0'
                  }}</span>
                </td>
                <ng-container *ngIf="!megaPricing.earlyCloseFlag">
                  <td class="td_cell pl-85">
                    <span id="pool-item-settlement-date">{{
                      megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy'
                    }}</span>
                  </td>
                </ng-container>
                <ng-container *ngIf="megaPricing.earlyCloseFlag">
                  <td class="td_cell pl-85">
                    <span id="pool-item-settlement-date-earlyClose fee-warning-red"
                      >{{ megaPricing?.tradeSettlementDate | date: 'MM/dd/yyyy' }}*</span
                    >
                  </td>
                </ng-container>
                <td class="td_cell td_cell--is-numeric">
                  <ng-container *ngIf="megaPricing?.prevFeeDollars !== null">
                    <ng-container *ngIf="showDisclaimer">
                      <span class="pool-item-trade-amount fw-bold fee-warning-red"
                        >{{
                          megaPricing?.prevFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                        }}*</span
                      >
                    </ng-container>
                    <ng-container *ngIf="!showDisclaimer">
                      <span class="pool-item-trade-amount fw-bold">{{
                        megaPricing?.prevFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                      }}</span>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="megaPricing?.prevFeeTicks !== null">
                    <ng-container *ngIf="showDisclaimer">
                      <span class="pool-item-trade-amount fw-bold fee-warning-red"
                        >{{ megaPricing?.prevFeeTicks | number: '1.3-3' }}/32*</span
                      >
                    </ng-container>
                    <ng-container *ngIf="!showDisclaimer">
                      <span class="pool-item-trade-amount fw-bold"
                        >{{ megaPricing?.prevFeeTicks | number: '1.3-3' }}/32</span
                      >
                    </ng-container>
                  </ng-container>
                </td>
                <td class="td_cell td_cell--is-numeric">
                  <ng-container *ngIf="megaPricing?.newFeeDollars !== null">
                    <ng-container *ngIf="showDisclaimer">
                      <span class="pool-item-trade-amount fw-bold fee-warning-red"
                        >{{
                          megaPricing?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                        }}*</span
                      >
                    </ng-container>
                    <ng-container *ngIf="!showDisclaimer">
                      <span class="pool-item-trade-amount fw-bold">{{
                        megaPricing?.newFeeDollars | currency: 'USD' : 'symbol' : '1.2-2'
                      }}</span>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="megaPricing?.newFeeTicks !== null">
                    <ng-container *ngIf="showDisclaimer">
                      <span class="fee-warning-red pool-item-trade-amount fw-bold"
                        >{{ megaPricing?.newFeeTicks | number: '1.3-3' }}/32*
                      </span>
                    </ng-container>
                    <ng-container *ngIf="!showDisclaimer">
                      <span class="pool-item-trade-amount fw-bold"
                        >{{ megaPricing?.newFeeTicks | number: '1.3-3' }}/32
                      </span>
                    </ng-container>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="fee-warning-red">{{ disclaimerMessage }}</p>
      </div>
    </div>
  </section>
  <div class="row" *ngIf="showEarlyCloseLegendPricingSummary">
    <div class="col-12 mt-25">
      <p>
        <i class="fa fa-asterisk legend-icon"></i>Market closes early on this day. Please be sure
        someone from the Structured Transactions team is available to complete this transaction.
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-12 mt-25">
      <div class="row">
        <div class="col-12">
          <label class="terms-conditions-title">Terms & Conditions</label>
        </div>
      </div>
      <div class="row">
        <div class="col-8">
          <p>
            By entering into a Supers transaction where the settlement is scheduled less than 48
            hours after the transaction has been booked, an investor is thereby agreeing to waive
            application of the 48-Hour Rule, as provided in Section B-2 of Chapter 7 of the Uniform
            Practices Manual, as published by the Securities Industry and Financial Markets
            Association.
          </p>
          <p>
            The use of this application is subject to the terms of your existing contractual
            arrangements with Fannie Mae including, without limitation, the Software Subscription
            Agreement or Technology License Agreement and any applicable contracts relating to the
            acquisition and distribution of Megas securities or Supers securities (collectively, the
            “Securities Contracts”). By clicking the “Commit” button below, you are entering into a
            legally-binding commitment under the applicable Securities Contracts to acquire Megas
            securities or Supers securities from Fannie Mae, as applicable, pursuant to the terms
            and conditions set forth in this application and any application-related confirmations.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <div class="commit-cancel">
        <button
          class="button fm-primary-button"
          (click)="megaCommitButtonClicked()"
          [disabled]="isCommitButtonClicked"
        >
          Commit
        </button>
        <button class="button fm-tertiary-button" (click)="showModelOne = true">
          {{ cancelBtnText }}
        </button>
      </div>
    </div>

    <div class="enter-mega-model-window" *ngIf="showModelOne">
      <div class="panel panel-default fadeInUpBig">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="showModelOne = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body mega-cancel-confirmation-model">
          <ng-container *ngIf="!isEditMegaFlow">
            <h4>Are you sure you want to leave this page?</h4>
            <br />
            <p>
              You are about to leave the page before you have committed to this trade. None of the
              information you have entered will be saved. To get it back you will need to create a
              new pool.
            </p>
            <br />
          </ng-container>
          <ng-container *ngIf="isEditMegaFlow">
            <p>
              You are attempting to cancel your pool edits.<br />By doing so, any changes you have
              made will be lost.<br />Your pool will revert to its original attributes.
            </p>
            <br />
            <h4>Do you wish to proceed?</h4>
            <br />
          </ng-container>
          <button class="button fm-tertiary-button" (click)="showModelOne = false">NO</button>
          <button
            class="button fm-primary-button"
            (click)="navigatePageTo('/mega-trade/enter-details')"
          >
            YES
          </button>
        </div>
      </div>
    </div>
    <div class="enter-mega-model-window" *ngIf="displayNavigateAwayPopup">
      <div class="panel panel-default fadeInUpBig">
        <button
          type="button"
          class="close float-end"
          aria-label="Close"
          (click)="displayNavigateAwayPopup = false"
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="panel-body mega-cancel-confirmation-model">
          <p>If you leave this page your work will not be saved.</p>
          <br />
          <h4>Do you wish to proceed?</h4>
          <br />
          <div class="col-12 col-sm-12 col-lg-12">
            <button class="button fm-tertiary-button" (click)="displayNavigateAwayPopup = false">
              Cancel
            </button>
            <button class="button fm-primary-button" (click)="navigatePageTo(destinationUrl)">
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
